import { rem } from "polished";
import styled from "styled-components";

export const FLOATING_MENU_SIZE = 48;

const BlockOutlineFloatingOptionButton = styled.button`
  background: none;
  border: none;
  height: ${rem(FLOATING_MENU_SIZE)};
  cursor: pointer;

  &:focus:not([data-focus-visible-added]) {
    outline: none;
  }
`;

const BlockOutlineFloatingOptionsWrapper = styled.div`
  background: #9444fb;
  display: grid;
  ${BlockOutlineFloatingOptionButton}:not(:last-of-type) {
    border-bottom: ${rem(2)} solid #fff;
  }
`;

export { BlockOutlineFloatingOptionsWrapper, BlockOutlineFloatingOptionButton };
